module.exports = [{
      plugin: require('../plugins/gatsby-source-cockpit/gatsby-browser.js'),
      options: {"plugins":[],"api_key":"USR-cbda7d55e4bedcacf7ef3b545b68a690c79e4f92","api_url":"http://cereales.gonza.me/api"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Cereales El Cruce Estático","short_name":"Cereales El Cruce Estático","start_url":"/","background_color":"#f7f0eb","theme_color":"#a2466c","display":"standalone","icon":"src/images/icon-static.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"72253922047004deace4e10485c0f104"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"precachePages":["/"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
